import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ExternalLink, Calendar, Clock, MapPin, Globe } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
export function BookingPage() {
  return <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-133">
      <div className="max-w-3xl mx-auto" data-id="element-134">
        <div className="mb-8 flex items-center justify-between" data-id="element-135">
          <Link to="/" className="inline-flex items-center text-gray-600 hover:text-gray-900 transition-colors" data-id="element-136">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-137" />
            Back to Home
          </Link>
          <div className="text-sm text-gray-500" data-id="element-138">PTC Event 2026</div>
        </div>

        <div className="text-center mb-12" data-id="element-139">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-140">
            Schedule a Meeting
          </h1>
          <p className="text-xl text-gray-600" data-id="element-141">
            Book a 30-minute conversation with Vivin Varghese at PTC Event 2026
          </p>
        </div>

        {/* Main Calendly Card */}
        <Card className="p-8 md:p-12 text-center space-y-8" data-id="element-142">
          <div className="flex justify-center" data-id="element-143">
            <div className="bg-blue-100 p-6 rounded-full" data-id="element-144">
              <Calendar className="w-16 h-16 text-blue-600" data-id="element-145" />
            </div>
          </div>

          <div data-id="element-146">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-147">
              Book via Calendly
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-148">
              Select your preferred time slot and receive instant confirmation
              with calendar sync.
            </p>
          </div>

          {/* Meeting Details */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 py-6 border-y border-gray-100" data-id="element-149">
            <div className="flex flex-col items-center gap-2" data-id="element-150">
              <Clock className="w-6 h-6 text-blue-600" data-id="element-151" />
              <p className="font-medium text-gray-900" data-id="element-152">30 minutes</p>
              <p className="text-sm text-gray-500" data-id="element-153">20 min + buffer</p>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-154">
              <MapPin className="w-6 h-6 text-blue-600" data-id="element-155" />
              <p className="font-medium text-gray-900" data-id="element-156">
                Hilton Hawaiian Village
              </p>
              <p className="text-sm text-gray-500" data-id="element-157">Honolulu, Hawaii</p>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-158">
              <Globe className="w-6 h-6 text-blue-600" data-id="element-159" />
              <p className="font-medium text-gray-900" data-id="element-160">HST Timezone</p>
              <p className="text-sm text-gray-500" data-id="element-161">Hawaii Standard Time</p>
            </div>
          </div>

          <a href="https://calendly.com/ctrls-vivin/meet-vivin-ptc-26" target="_blank" rel="noopener noreferrer" className="block" data-id="element-162">
            <Button size="lg" className="w-full max-w-md mx-auto text-lg py-6" data-id="element-163">
              Open Calendly to Book
              <ExternalLink className="ml-2 w-5 h-5" data-id="element-164" />
            </Button>
          </a>

          <p className="text-sm text-gray-500" data-id="element-165">
            Confirmation will be sent to{' '}
            <strong data-id="element-166">vivin.varghese@ctrls.in</strong>
          </p>
        </Card>

        {/* Additional Info */}
        <div className="mt-8 text-center" data-id="element-167">
          <p className="text-gray-600 mb-4" data-id="element-168">
            Questions?{' '}
            <Link to="/contact" className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-169">
              Get in touch
            </Link>
          </p>
        </div>
      </div>
    </div>;
}